export default {
    state: {
        recurringViberCampaign: localStorage.getItem('recurringViberCampaign') ?? {}
    },
    mutations: {
        setRecurringViberCampaign(state, campaign) {
            state.recurringViberCampaign = campaign
        }
    },
    actions: {
        setRecurringViberCampaign({ commit }, campaign) {
            localStorage.setItem('recurringViberCampaign', campaign)
            commit('setRecurringViberCampaign', campaign)
        }
    },
    getters: {
        getCurrentRecurringViberCampaign: state => state.recurringViberCampaign
    }
}
